import { render, staticRenderFns } from "./specificAct.vue?vue&type=template&id=52dfec11&scoped=true&"
import script from "./specificAct.vue?vue&type=script&lang=js&"
export * from "./specificAct.vue?vue&type=script&lang=js&"
import style0 from "./specificAct.vue?vue&type=style&index=0&id=52dfec11&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dfec11",
  null
  
)

export default component.exports